displayErrorsOnPageLoad();
$('[data-ajax-route]').on('click', function () {
    let targetContainer = $(this).data('target');
    let ajaxRoute = $(this).data('ajax-route');
    ajax(ajaxRoute, targetContainer, true)
});

function displayErrorsOnPageLoad() {
    let errors = $('#errors').data('errors');

    $('.modal').each(function () {
        let targetContainer = this;
        let formData = getFormData($(this).find('form'));
        $.each(errors, function (key, val) {
            if (formData[key] !== undefined) { // modal laten zien wanneer error key aanwezig is.
                $(targetContainer).modal('show');
                return false;
            }
        })
    });
}

function ajax(ajax_url, targetContainer, jsonParse = false) {
    $.ajax({
        url: ajax_url,
        method: 'get',
        dataType: 'JSON',
        success: function (response) {
            fillFormWithJsonData(response, targetContainer);
        }
    });
}

function fillFormWithJsonData(jsonData, targetContainer) {
    $(targetContainer).each(function () {
        let targetInputFields = $(this).find(':input, select, textarea');
        $.each(targetInputFields, function () {
            let key = $(this).attr('name');
            if (jsonData.hasOwnProperty(key)) {
                /** Skip is prefilled by PHP if available */
                if (key === 'birthday') {
                    return;
                }

                if ($(this).attr('type') === 'checkbox') {
                    $(this).prop("checked", jsonData[key])
                } else {
                    $(this).val(jsonData[key])
                }

            }
        });
    });
}

function getFormData(form) {
    let formData = $(form).serializeArray()
    let data = {}
    $.each(formData, function () {
        data[this.name] = this.value
    })
    return data
}

$('.toggle-source').each(function () {
    toggleVisibility(this);
})

$('.toggle-source').on('change', function () {
    toggleVisibility(this);
})

function toggleVisibility(dom) {
    let targets = $(dom).data('target');
    $.each(targets, function (i, item) {
        $(item).hide();
    })
    let key = $(dom).find('select').val();
    $(targets[key]).show();
}

$(document).ready(() => {
    $('textarea#value').each(function () {
        window.resizeTextarea(this);
    });

    /**
     * Add the click function for the (de)activation of the cancellation insurance.
     */
    $('#cancellation_insurance-btn').off('click keydown').on('click keydown', function () {
        let btn = $(this);

        if (btn.data('needs-birthday')) {
            alert('Vul eerst de geboortedatum in van de gast, daarna kan de verzekering geactiveerd worden.');
            $("[data-target='#edit-contact']").click();
            return;
        }

        let message = 'Weet je zeker dat je groepsannuleringsverzekering wilt '
            + ((btn.attr('data-cancellation_insurance') === '1') ? 'deactiveren' : 'activeren')
            + '?';
        va_confirm(message, () => {
            // Do the (de)activating.
            $.ajax({
                method: "GET",
                url: btn.attr('data-ajax-route')
                    + '/'
                    + ((btn.attr('data-cancellation_insurance') === '1') ? '0' : '1'),
                headers: {
                    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                }
            }).done(results => {
                btn.attr('data-cancellation_insurance', results.active);
                btn.html(((parseInt(results.active) === 1) ? 'Deactiveren' : 'Activeren'));
                $('#cancellation-insurance-display').html(((parseInt(results.active) === 1) ? 'Ja' : 'Nee'))
                if (parseInt(results.handled) === 1) {
                    btn.attr('disabled', 'disabled');
                }
            });
        }, () => {
        })
    });
});
